import { Shark, View } from "shark-mvc";

import templateContent from "./accept-invitation.html";

import OrganizationMembership from "../../models/OrganizationMembership";
import User from "../../models/User";

import messageModalComponent from "../../components/messageModal/messageModalComponent";
import organizationMembershipManager from "../../managers/organizationMembershipManager";
import signView from "../sign/signView";
import userManager from "../../managers/userManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class AcceptInvitationView extends View {
	constructor () {
		super("acceptInvitationView");

		this.setTemplate(templateContent);
		this.$mainRoute = "accept-invitation";
	}

	beforeLoad () {
		const urlParams = new URLSearchParams(document.location.search);

		if (urlParams.has("guid")) {
			waitBoxComponent.open();

			organizationMembershipManager.checkUserRegistration(urlParams.get("guid"))
			.then(response => {
				// console.log({response});
				const currOrganizationMembership = new OrganizationMembership({
					guid: urlParams.get("guid"),
				});

				Shark.set({
					invitationAccepted: false,
					codeIsInvalid: response?.data?.rc === 404,
					currOrganizationMembership,
					newUser: new User({
						email: response?.data?.items?.[0]?.inviteEMail,
						preferences: {
							theme: "theme-2",
						},
						preserveLogin: true,
					}),
					requestGuid: urlParams.get("guid"),
					userAlredySignedUp: response?.data?.items?.[0]?.guid,
				});


				waitBoxComponent.close();
			});
		}
		else {
			Shark.set({
				codeIsInvalid: true,
			});
		}
	}

	init () {
		this.addComponents([messageModalComponent, waitBoxComponent]);

		document.body.classList.add("theme-2");

		Shark.set({
			invitationAccepted: false,
			requestGuid: null,
		});
	}

	async saveInviteAcceptance (organizationMembership) {
		waitBoxComponent.open();
		const acceptResult = await organizationMembershipManager.accept(organizationMembership.guid);
		// console.log({acceptResult});

		Shark.set({
			invitationAccepted: acceptResult.data.rc === 1,
		});

		waitBoxComponent.close();
	}

	saveInviteAcceptanceBtn_clickHandler () {
		const { currOrganizationMembership } = Shark.get();
	
		if (currOrganizationMembership) {
			this.saveInviteAcceptance(currOrganizationMembership);
		}
	}

	saveUserAndInviteAcceptanceBtn_clickHandler () {
		const { newUser } = Shark.get();

		if (newUser.firstName === "" || newUser.lastName === "" || newUser.email === "") {
			messageModalComponent.open("Attenzione, tutti i dati sono obbligatori");
			return;
		}

		if (newUser.password === "" || newUser.password !== newUser.__passwordCheck) {
			messageModalComponent.open("Attenzione, la password è obbligatoria e deve corrispondere a quella di verifica");
			return;
		}

		waitBoxComponent.open();

		userManager.save(newUser)
		.then(async () => {
			const { currOrganizationMembership } = Shark.get();
			
			if (currOrganizationMembership) {
				await this.saveInviteAcceptance(currOrganizationMembership);
			}
			
			localStorage.setItem("lastUserEMail", newUser.email);
	
			waitBoxComponent.close();

			Shark.openPage(signView);
		});
	}
}

const acceptInvitationView = new AcceptInvitationView();

Shark.registerView(acceptInvitationView);

export default acceptInvitationView;
